var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleStoreBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 189,
    height: 56,
    viewBox: "0 0 189 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M20.725-7.7l-.105-.1a2.807,2.807,0,0,1-.647-1.967V-40.318a2.7,2.7,0,0,1,.75-2.071L38.068-25.043,20.725-7.7m-.752-32.834c0-.077,0-.153.006-.227,0,.074-.006.15-.006.227m.006-.23v0m0-.01h0",
    transform: "translate(-19.973 42.389)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M0,24H217V-60H0Z",
    transform: "translate(0 60)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.66,
    y1: 0.765,
    x2: 0.816,
    y2: 0.765,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00abff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00b7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00c1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00c9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00d1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00d6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#00dbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#00e1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e2ff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M38.68-22.359h0l.132-.074,6.85-3.892a3,3,0,0,0,1.3-1.3,3,3,0,0,1-1.3,1.3l-6.85,3.892-.132.074m0-.2L32.9-28.347l5.783-5.783,6.98,3.966a2.609,2.609,0,0,1,1.467,1.816v0a2.609,2.609,0,0,1-1.467,1.816l-6.98,3.966",
    transform: "translate(-32.898 34.13)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.717,
    y1: 0.5,
    x2: 0.873,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdf00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "gold"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffce00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffc600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffb600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ffb000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ffa900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ffa400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ffa000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M21.773-12a1.8,1.8,0,0,1-1.238-.455h0A1.806,1.806,0,0,0,21.775-12c.042,0,.084,0,.127,0-.043,0-.087,0-.129,0m0-.2a1.8,1.8,0,0,1-1.236-.455L37.88-30l5.783,5.783L23.343-12.67a3.223,3.223,0,0,1-1.569.47m-1.242-.253c-.031-.028-.06-.057-.09-.088l.09.088",
    transform: "translate(-20.442 29.999)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.709,
    y1: 0.688,
    x2: 0.921,
    y2: 0.688,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#f93547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f3314a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ed2d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#e72950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e12553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#db2155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#d41d59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#cf195b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#c9155e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31161"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M37.854-24.855h0L20.509-42.2a1.8,1.8,0,0,1,1.236-.454,3.236,3.236,0,0,1,1.571.47L43.637-30.638l-5.783,5.783m5.914-5.914L23.316-42.389a3.232,3.232,0,0,0-1.571-.47h0a3.212,3.212,0,0,1,1.569.47l20.451,11.62M21.734-42.859h0",
    transform: "translate(-20.509 42.859)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.128,
    y1: 0.688,
    x2: 0.222,
    y2: 0.688,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#319f70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2baa71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#25b371"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#1fbd72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#19c773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#13d074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0fd874"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0adf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06e675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#03eb75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ef76"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M21.777-13.647A1.806,1.806,0,0,1,20.54-14.1h0s0,0,0,0l-.09-.088-.008-.01.1-.1a1.8,1.8,0,0,0,1.236.455,3.223,3.223,0,0,0,1.569-.47L43.666-25.868l.13.13-.132.074L23.345-14.118a3.336,3.336,0,0,1-1.441.468c-.043,0-.085,0-.127,0",
    transform: "translate(-20.436 25.868)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.709,
    y1: 0.688,
    x2: 0.921,
    y2: 0.688,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cc2d36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#c72a38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#c2273a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#bd243d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#b8213f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#b31e42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#af1a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#aa1746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#a51449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#a0114b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c0e4e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M20.62-16.916h0a2.807,2.807,0,0,1-.647-1.967v-.2a2.807,2.807,0,0,0,.647,1.967l.105.1-.105.1",
    transform: "translate(-19.973 19.087)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.66,
    y1: 0.765,
    x2: 0.816,
    y2: 0.765,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#008ddf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0096df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00a0df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00a9df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00b0df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00b7df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00bcdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#00c1df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00c4df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#00c5df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c6df"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M37.159-24.086h0l-.13-.13,6.98-3.966A2.609,2.609,0,0,0,45.477-30a1.732,1.732,0,0,1-.162.722,3.005,3.005,0,0,1-1.3,1.3l-6.85,3.892",
    transform: "translate(-37.029 29.998)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.717,
    y1: 0.5,
    x2: 0.873,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfc500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#dfbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#dfb500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#dfae00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#dfa600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#dfa000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#df9b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#df9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#df9000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#df8c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#df8800"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M45.477-28.311a2.609,2.609,0,0,0-1.467-1.816l-6.98-3.966.13-.13,6.85,3.893a2.457,2.457,0,0,1,1.467,2.019",
    transform: "translate(-37.029 34.223)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.717,
    y1: 0.5,
    x2: 0.873,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ffe140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffdb40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffd540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ffce40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffc940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ffc440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ffbf40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ffbb40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ffb840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb540"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M19.973-40.26v-.213h0c0-.077,0-.153.006-.227v-.006a.013.013,0,0,1,0-.007h0a2.664,2.664,0,0,1,.64-1.718l.1.1a2.7,2.7,0,0,0-.75,2.071m.748-2.271,0,0s0,0,0,0",
    transform: "translate(-19.973 42.535)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.66,
    y1: 0.765,
    x2: 0.816,
    y2: 0.765,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40b8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#40c0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#40c8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#40d0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#40d6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#40dcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#40e0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#40e4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#40e7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#40e8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40eaff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M43.667-30.638,23.346-42.184a3.236,3.236,0,0,0-1.571-.47,1.8,1.8,0,0,0-1.236.454l-.1-.1c.032-.034.066-.067.1-.1,0,0,0,0,0,0a1.8,1.8,0,0,1,1.225-.454h.011a3.232,3.232,0,0,1,1.571.47L43.8-30.769l-.13.13",
    transform: "translate(-20.435 42.859)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.128,
    y1: 0.688,
    x2: 0.222,
    y2: 0.688,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#64b894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#60bf95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5cc695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#57ce96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#53d596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4fdc97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4be197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#47e797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#44ec97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#42f097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40f497"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M37.028-25.7h0l.132-.074-.132.074",
    transform: "translate(-37.028 25.775)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.717,
    y1: 0.5,
    x2: 0.873,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccb300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ccac00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#cca500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#cc9e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#cc9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#cc9200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#cc8d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#cc8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#cc8300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#cc8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc7c00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M20.436-17.506h0l.105-.1-.1.1",
    transform: "translate(-20.435 17.61)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.709,
    y1: 0.688,
    x2: 0.921,
    y2: 0.688,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#df333b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#da2f3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d52b41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#d02843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ca2446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c52148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c01d4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ba194e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#b51650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#b01253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ab0f55"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(-472.14 -689.876)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M192,6H17a7.021,7.021,0,0,1-7-7V-43a7.021,7.021,0,0,1,7-7H192a7.021,7.021,0,0,1,7,7V-1a7.021,7.021,0,0,1-7,7",
    transform: "translate(462.14 739.876)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M192-50H17a7.021,7.021,0,0,0-7,7V-1a7.021,7.021,0,0,0,7,7H192a7.021,7.021,0,0,0,7-7V-43a7.021,7.021,0,0,0-7-7m0,1.12A5.886,5.886,0,0,1,197.88-43V-1A5.886,5.886,0,0,1,192,4.88H17A5.886,5.886,0,0,1,11.12-1V-43A5.886,5.886,0,0,1,17-48.88H192",
    transform: "translate(462.14 739.876)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M59.846-38.406A3.791,3.791,0,0,1,58.8-35.6a4.069,4.069,0,0,1-3.086,1.243,4.226,4.226,0,0,1-3.091-1.261,4.225,4.225,0,0,1-1.273-3.126,4.222,4.222,0,0,1,1.273-3.126,4.226,4.226,0,0,1,3.091-1.261,4.348,4.348,0,0,1,1.725.351,3.456,3.456,0,0,1,1.313.939l-.738.738a2.839,2.839,0,0,0-2.3-1,3.186,3.186,0,0,0-2.293.932,3.213,3.213,0,0,0-.969,2.422,3.213,3.213,0,0,0,.969,2.422,3.186,3.186,0,0,0,2.293.932,3.188,3.188,0,0,0,2.346-.937,2.646,2.646,0,0,0,.7-1.7H55.716v-1.008h4.071a3.585,3.585,0,0,1,.059.633",
    transform: "translate(478.681 742.622)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M59.886-38.366h-.14a3.649,3.649,0,0,1-1,2.7h0a3.932,3.932,0,0,1-2.985,1.2,4.083,4.083,0,0,1-2.992-1.221,4.08,4.08,0,0,1-1.232-3.027,4.08,4.08,0,0,1,1.232-3.027,4.083,4.083,0,0,1,2.992-1.221,4.191,4.191,0,0,1,1.669.34,3.322,3.322,0,0,1,1.263.9l.106-.09-.1-.1-.738.739.1.1.106-.09A2.976,2.976,0,0,0,55.756-42.2a3.334,3.334,0,0,0-2.391.972,3.354,3.354,0,0,0-1.011,2.523,3.354,3.354,0,0,0,1.011,2.523,3.341,3.341,0,0,0,2.391.973,3.327,3.327,0,0,0,2.446-.98,2.783,2.783,0,0,0,.745-1.788l.013-.153H55.9v-.729h3.931V-39l-.139.024a3.476,3.476,0,0,1,.057.609h.28a3.728,3.728,0,0,0-.062-.658l-.021-.115H55.616v1.288h3.191v-.14L58.666-38A2.5,2.5,0,0,1,58-36.388a3.044,3.044,0,0,1-2.247.9,3.055,3.055,0,0,1-2.2-.893,3.075,3.075,0,0,1-.925-2.323,3.075,3.075,0,0,1,.925-2.323,3.048,3.048,0,0,1,2.2-.892,2.691,2.691,0,0,1,2.192.946l.1.116.847-.847.091-.09-.083-.1a3.612,3.612,0,0,0-1.366-.977,4.494,4.494,0,0,0-1.779-.363,4.363,4.363,0,0,0-3.189,1.3,4.363,4.363,0,0,0-1.315,3.226,4.369,4.369,0,0,0,1.315,3.227,4.367,4.367,0,0,0,3.189,1.3,4.218,4.218,0,0,0,3.188-1.287l-.1-.1.1.1a3.939,3.939,0,0,0,1.085-2.9h-.14",
    transform: "translate(478.641 742.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M63.429-41.968H59.6V-39.3h3.45V-38.3H59.6v2.664h3.826V-34.6h-4.9V-43h4.9v1.032",
    transform: "translate(481.55 742.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M63.469-41.928v-.14H59.5v2.944h3.45v.728H59.5v2.944h3.826v.752H58.7v-8.12h4.624v.892h.14v0h.14V-43.1H58.425v8.68h5.184v-1.312H59.783v-2.384h3.45V-39.4h-3.45v-2.384h3.826v-.14h-.14",
    transform: "translate(481.51 742.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M66.258-34.6H65.177v-7.368H62.832V-43H68.6v1.032H66.258V-34.6",
    transform: "translate(483.273 742.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M66.3-34.56v-.14h-.941v-7.368H63.011v-.752H68.5v.752H66.158v7.508h.14v0h.14v-7.228h2.346V-43.1H62.731v1.312h2.346v7.368h1.361v-.14H66.3",
    transform: "translate(483.232 742.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M69.938-34.6h1.079V-43H69.938Z",
    transform: "translate(486.115 742.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M69.978-34.56h.14v-8.26h.8v8.12h-.938v.14h0v.14H71.2V-43.1H69.838v8.68h.14v-.14",
    transform: "translate(486.075 742.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M75.107-34.6H74.027v-7.368H71.681V-43h5.772v1.032H75.107V-34.6",
    transform: "translate(486.812 742.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M75.147-34.56v-.14h-.939v-7.368H71.861v-.752h5.492v.752H75.007v7.508h.14v0h.14v-7.228h2.346V-43.1H71.581v1.312h2.346v7.368h1.359v-.14h-.14",
    transform: "translate(486.772 742.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M80.36-36.336a3.085,3.085,0,0,0,2.282.944,3.078,3.078,0,0,0,2.282-.944,3.29,3.29,0,0,0,.934-2.411,3.29,3.29,0,0,0-.934-2.411,3.078,3.078,0,0,0-2.282-.944,3.085,3.085,0,0,0-2.282.944,3.294,3.294,0,0,0-.932,2.411A3.294,3.294,0,0,0,80.36-36.336Zm5.362.7a4.122,4.122,0,0,1-3.08,1.273,4.119,4.119,0,0,1-3.079-1.273,4.3,4.3,0,0,1-1.238-3.115,4.3,4.3,0,0,1,1.238-3.115,4.119,4.119,0,0,1,3.079-1.273,4.116,4.116,0,0,1,3.074,1.278,4.294,4.294,0,0,1,1.243,3.109,4.3,4.3,0,0,1-1.238,3.115",
    transform: "translate(489.47 742.622)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M80.4-36.3l-.1.1a3.226,3.226,0,0,0,2.381.987,3.224,3.224,0,0,0,2.381-.987,3.423,3.423,0,0,0,.974-2.509,3.425,3.425,0,0,0-.974-2.509,3.223,3.223,0,0,0-2.381-.986,3.225,3.225,0,0,0-2.381.986,3.435,3.435,0,0,0-.973,2.509A3.433,3.433,0,0,0,80.3-36.2l.2-.2a3.147,3.147,0,0,1-.893-2.313,3.147,3.147,0,0,1,.893-2.313h0a2.943,2.943,0,0,1,2.183-.9,2.937,2.937,0,0,1,2.183.9,3.149,3.149,0,0,1,.893,2.313,3.149,3.149,0,0,1-.893,2.313,2.938,2.938,0,0,1-2.183.9,2.95,2.95,0,0,1-2.183-.9Zm5.362.7-.1-.1a3.98,3.98,0,0,1-2.981,1.231A3.972,3.972,0,0,1,79.7-35.689l0,0,0,0a4.155,4.155,0,0,1-1.2-3.017,4.155,4.155,0,0,1,1.2-3.017,3.972,3.972,0,0,1,2.978-1.231,3.982,3.982,0,0,1,2.975,1.236,4.154,4.154,0,0,1,1.2,3.011,4.159,4.159,0,0,1-1.2,3.017l.2.195a4.436,4.436,0,0,0,1.277-3.212,4.435,4.435,0,0,0-1.282-3.206,4.259,4.259,0,0,0-3.175-1.322A4.262,4.262,0,0,0,79.5-41.918a4.439,4.439,0,0,0-1.277,3.212A4.437,4.437,0,0,0,79.5-35.495l0,0,0,0a4.257,4.257,0,0,0,3.179,1.316,4.26,4.26,0,0,0,3.181-1.316l-.1-.1",
    transform: "translate(489.43 742.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M85.575-34.6V-43H86.89l4.082,6.534h.046l-.046-1.618V-43h1.079v8.4H90.924l-4.27-6.852h-.048l.048,1.62V-34.6H85.575",
    transform: "translate(492.37 742.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M85.615-34.56h.14v-8.26h1.1l4.082,6.535H91.2l-.05-1.761V-42.82h.8v8.12h-.909l-4.271-6.852H86.5l.05,1.761v5.09h-.939v.14h0v.14h1.219v-5.375l-.048-1.62-.14,0v.14h.048v-.14l-.119.074,4.312,6.917h1.344V-43.1H90.872v5.058l.046,1.62.14,0v-.139h-.046v.139l.119-.073-4.124-6.6H85.475v8.68h.14v-.14",
    transform: "translate(492.33 742.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M143.294-14.819h2.612v-17.5h-2.612Zm23.53-11.2-2.995,7.588h-.09l-3.108-7.588h-2.814l4.661,10.6-2.657,5.9h2.726l7.182-16.5Zm-14.815,9.209c-.857,0-2.05-.427-2.05-1.485,0-1.351,1.487-1.869,2.769-1.869a4.656,4.656,0,0,1,2.387.585A3.167,3.167,0,0,1,152.009-16.807Zm.315-9.591a4.9,4.9,0,0,0-4.661,2.68l2.318.967a2.477,2.477,0,0,1,2.387-1.284,2.515,2.515,0,0,1,2.747,2.253v.179a5.778,5.778,0,0,0-2.724-.675c-2.5,0-5.044,1.373-5.044,3.94,0,2.342,2.05,3.851,4.346,3.851a3.686,3.686,0,0,0,3.333-1.712h.09v1.351h2.521v-6.709C157.637-24.665,155.318-26.4,152.324-26.4Zm-16.145,2.513h-3.716v-6h3.716a3.032,3.032,0,0,1,3.062,3A3.049,3.049,0,0,1,136.179-23.885Zm-.067-8.435h-6.259v17.5h2.611v-6.63h3.648a5.547,5.547,0,0,0,5.741-5.436A5.545,5.545,0,0,0,136.112-32.32ZM101.978-16.8a3.416,3.416,0,0,1-3.315-3.585,3.444,3.444,0,0,1,3.315-3.632,3.355,3.355,0,0,1,3.179,3.632A3.326,3.326,0,0,1,101.978-16.8Zm3-8.232h-.09a4.127,4.127,0,0,0-3.135-1.33,5.921,5.921,0,0,0-5.706,5.977,5.9,5.9,0,0,0,5.706,5.932,4.056,4.056,0,0,0,3.135-1.354h.09v.857c0,2.279-1.217,3.5-3.179,3.5a3.3,3.3,0,0,1-3-2.121l-2.278.948A5.674,5.674,0,0,0,101.8-9.112c3.067,0,5.662-1.8,5.662-6.2V-26.006h-2.482Zm4.287,10.217h2.617v-17.5h-2.617Zm6.472-5.774a3.267,3.267,0,0,1,3.112-3.473,2.3,2.3,0,0,1,2.211,1.263Zm8.12-1.985a5.534,5.534,0,0,0-5.1-3.788,5.658,5.658,0,0,0-5.615,5.954,5.826,5.826,0,0,0,5.908,5.954,5.922,5.922,0,0,0,4.963-2.639l-2.03-1.354a3.4,3.4,0,0,1-2.933,1.646,3.03,3.03,0,0,1-2.887-1.8l7.962-3.293ZM60.425-24.539v2.526h6.044a5.28,5.28,0,0,1-1.375,3.181,6.194,6.194,0,0,1-4.669,1.848,6.633,6.633,0,0,1-6.632-6.72,6.633,6.633,0,0,1,6.632-6.721,6.44,6.44,0,0,1,4.556,1.8L66.763-30.4a8.813,8.813,0,0,0-6.338-2.549A9.378,9.378,0,0,0,51.042-23.7a9.376,9.376,0,0,0,9.383,9.247,8.45,8.45,0,0,0,6.45-2.594,8.347,8.347,0,0,0,2.188-5.909,8.161,8.161,0,0,0-.136-1.578ZM75.935-16.8a3.445,3.445,0,0,1-3.361-3.608,3.431,3.431,0,0,1,3.361-3.609,3.431,3.431,0,0,1,3.36,3.609A3.444,3.444,0,0,1,75.935-16.8Zm0-9.562a5.869,5.869,0,0,0-5.978,5.954,5.884,5.884,0,0,0,5.978,5.954,5.883,5.883,0,0,0,5.977-5.954A5.869,5.869,0,0,0,75.935-26.366ZM88.974-16.8a3.445,3.445,0,0,1-3.361-3.608,3.431,3.431,0,0,1,3.361-3.609,3.43,3.43,0,0,1,3.36,3.609A3.444,3.444,0,0,1,88.974-16.8Zm0-9.562A5.869,5.869,0,0,0,83-20.412a5.883,5.883,0,0,0,5.977,5.954,5.883,5.883,0,0,0,5.977-5.954,5.869,5.869,0,0,0-5.977-5.954",
    transform: "translate(478.557 746.695)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(486.102 700.531)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(-27.962 -24.655)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(259 42) rotate(135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M153.442,212.839,0,59.4,59.4,0,212.839,153.442Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(504.197 712.094)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(-46.057 -36.218)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(217 84) rotate(-180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M217,84H0V0H217Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(486.759 717.877)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(-28.619 -42.001)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(259 42) rotate(135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M153.442,212.839,0,59.4,59.4,0,212.839,153.442Z",
    fill: "url(#linear-gradient-3)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(486.852 699.873)",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(-28.713 -23.997)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(108.5 -108.5) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M0,153.442,153.442,0l59.4,59.4L59.4,212.839Z",
    fill: "url(#linear-gradient-4)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(486.75 723.661)",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(-28.61 -47.785)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(259 42) rotate(135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M153.442,212.839,0,59.4,59.4,0,212.839,153.442Z",
    fill: "url(#linear-gradient-5)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(486.102 733.154)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(-27.962 -57.278)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(259 42) rotate(135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M153.442,212.839,0,59.4,59.4,0,212.839,153.442Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-6)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(509.98 717.879)",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(-51.841 -42.003)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(217 84) rotate(-180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M217,84H0V0H217Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-7)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(509.98 711.964)",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(-51.841 -36.088)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(217 84) rotate(-180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M217,84H0V0H217Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-8)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(486.102 700.327)",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(-27.962 -24.451)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(259 42) rotate(135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M153.442,212.839,0,59.4,59.4,0,212.839,153.442Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-9)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(486.749 699.873)",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    transform: "translate(-28.609 -23.997)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(108.5 -108.5) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M0,153.442,153.442,0l59.4,59.4L59.4,212.839Z",
    fill: "url(#linear-gradient-10)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(509.979 723.791)",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(-51.839 -47.915)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(217 84) rotate(-180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M217,84H0V0H217Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-11)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(486.749 735.222)",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(-28.609 -59.346)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(259 42) rotate(135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M153.442,212.839,0,59.4,59.4,0,212.839,153.442Z",
    fill: "url(#linear-gradient-12)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleStoreBadge);
export default __webpack_public_path__ + "static/media/Google Store Badge.20025a9e693a306cb41116170b448b19.svg";
export { ForwardRef as ReactComponent };